<template>
  <div
    style="position: relative; overflow: scroll;"
    :style="{height: parsedHeight, width: parsedWidth}"
  >
    <table
      :ref="reference"
      :style="{opacity: gridOpacity, width: `${canvasWidth}px`}"
      class="grid-container"
    >
      <tr
        v-for="i in parseInt(rows) || 0"
        :key="`grid-${reference}-horizontal-line-${i}`"
      >
        <td 
          v-for="j in parseInt(cols) || 0"
          :key="`grid-${reference}-vertical-line-${j}`"
        />
      </tr>
    </table>
    <div 
      class="grid-overlay"
      :style="{opacity: overlayOpacity}"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'GridTemplate',
  props: {
    height: [String, Number],
    width: [String, Number],
    canvasWidth: {
      type: Number,
      required: true
    },
    canvasHeight: {
      type: Number,
      required: true
    },
    cols: {
      validator (value) {return !isNaN(value)}
    },
    rows: {
      validator (value) {return !isNaN(value)}
    },
    gridOpacity: {
      type: [String, Number],
      default: '20%'
    },
    overlayOpacity: {
      type: [String, Number],
      default: '80%',
    },
    reference: { // Use if you have multiple grids
      type: String,
      default: 'gridContainer'
    }
  },
  data () {
    return {}
  },
  computed: {
    parsedHeight () {return this.parseDimension('height')},
    parsedWidth () {return this.parseDimension('width')},
  },
  methods: {
    parseDimension (prop) {
      if (!this[prop]) return '100%'
      if (!isNaN(this[prop])) return this[prop] + 'px'
      else return this[prop]
    },
  }
}
</script>

<style scoped>
.grid-container {
  position: absolute;
  top: 0px;
  left: 0px;
  height: 100%;
  z-index: 1;
  border-spacing: 0px;
}
.grid-container tr td {
  border: 1px solid grey;
}
.grid-overlay {
  position: absolute;
  top: 0px;
  left: 0px;
  height: 100%;
  width: 100%;
  z-index: 2;
}
</style>